import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';
import { useLocale } from '@redlink/assets/locale';

export const FieldViewer = memo(({ title, value, style, en }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();
  return (
    <View {...{ style }}>
      <View>
        <Text style={styles.titleText}>{title}</Text>
        {value && (
          <Text {...{ en }} style={styles.valueText}>
            {value}
          </Text>
        )}
        {!value && (
          <Text style={styles.emptyValueText}>{dictionary.notExist}</Text>
        )}
      </View>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  titleText: {
    fontSize: 10,
    color: colors.gray21,
  },
  valueText: {
    fontSize: 16,
    color: colors.gray23,
    textAlign: 'right',
  },
  emptyValueText: {
    fontSize: 14,
    color: colors.gray22,
    textAlign: 'right',
  },
}));
